import React from "react";
import { Link } from "react-router-dom";

export default function BreadCrumb(props) {
  return (
    <ul className="breadcrumb">
      <li>
        <Link to="/">
          <i className="fa fa-home"></i>
        </Link>
      </li>
      <li>
        <a href=""> / {props.title}</a>
      </li>
    </ul>
  );
}
